export default __webpack_public_path__ + "static/media/ic_contact_phone_white.df71ceaf.svg";